// extracted by mini-css-extract-plugin
export var footer = "_ra-0";
export var inherit = "_ra-1";
export var input = "_ra-2";
export var modalContent = "_ra-3";
export var quillEditor = "_ra-4";
export var subtitle = "_ra-5";